<route>
{
  "meta": {
    "permission": [
      "inventory.view_movement"
    ]
  }
}
</route>

<template>
  <i-table
    title="Productos Inventariables"
    :headers="headers"
    app="inventory.movement"
    api="inventory"
    :opt="{
      company_id: company.pk,
      report_type: 'inventory'
    }"
    dontCreate
    dontRemove
    @click:edit="changeRoute"
  >
    <template v-slot:item.updated_date="{ item }">
      <span v-text="dateFormat(item.updated_date)"></span>
    </template>
    <template v-slot:extraToolbar>
      <v-divider class="mx-4" inset vertical></v-divider>
    </template>
  </i-table>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    headers() {
      return [
        {
          text: this.$tc('code', 2),
          value: 'internalCode'
        },
        {
          text: this.$tc('product', 1),
          value: 'name'
        },
        {
          text: this.$tc('cost', 2),
          value: 'cost',
          align: 'right'
        },
        {
          text: this.$t('pricesuggest'),
          value: 'priceSuggest',
          align: 'right'
        },
        {
          text: this.$t('stock'),
          value: 'quantity',
          align: 'right'
        },
        {
          text: this.movementBtn.edit ? this.$t('action') : '',
          value: this.movementBtn.edit ? 'actions' : ''
        }
      ]
    },
    ...mapGetters({
      getPermissions: 'session/getPermissions',
      isAdmin: 'session/isAdmin',
      company: 'company/getCompanyData'
    }),
    movementBtn() {
      return {
        delete:
          this.getPermissions([`inventory.delete_movement`]) || this.isAdmin,
        edit: this.getPermissions([`inventory.change_movement`]) || this.isAdmin
      }
    }
  },
  methods: {
    changeRoute(item) {
      this.$router.push({
        name: 'movement-pk',
        params: { pk: this.codification({ code: 'create' }) },
        query: { product_id: item.pk }
      })
    }
  }
}
</script>
